import React, { useEffect, useState } from "react";
import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import CreatePage from "./CreatePage";
import ManagePage from "./ManagePage";
import ConfirmadosPage from "./ConfirmadosPage";
import { auth } from "../../utils/firebase.config";
import "./style.css";

const AdminPanel = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authUser, setAuthUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authBusy, setAuthBusy] = useState(false);
  const [authError, setAuthError] = useState("");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthUser(user);
      setAuthLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    setAuthBusy(true);
    setAuthError("");

    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      setPassword("");
    } catch (loginError) {
      console.error("admin login error", loginError);
      setAuthError("Credenciales inválidas o usuario sin permisos.");
    } finally {
      setAuthBusy(false);
    }
  };

  const handleLogout = async () => {
    setAuthBusy(true);
    setAuthError("");
    try {
      await signOut(auth);
    } catch (logoutError) {
      console.error("admin logout error", logoutError);
      setAuthError("No se pudo cerrar sesión. Inténtalo de nuevo.");
    } finally {
      setAuthBusy(false);
    }
  };

  if (authLoading) {
    return (
      <section id="admin-panel">
        <div className="container">
          <div className="admin-auth-card">
            <p className="admin-panel-label">Lucero &amp; Miguel</p>
            <h2 className="admin-panel-title">Panel de Invitaciones</h2>
            <div className="admin-panel-rule"></div>
            <p className="status">Verificando acceso...</p>
          </div>
        </div>
      </section>
    );
  }

  if (!authUser) {
    return (
      <section id="admin-panel">
        <div className="container">
          <div className="admin-auth-card">
            <p className="admin-panel-label">Lucero &amp; Miguel</p>
            <h2 className="admin-panel-title">Panel de Invitaciones</h2>
            <div className="admin-panel-rule"></div>
            <p className="admin-panel-subtitle">Acceso restringido</p>
            <p className="admin-panel-hint">Inicia sesión con una cuenta de administrador.</p>

            <form className="admin-auth-form" onSubmit={handleLogin}>
              <div className="field-block">
                <label htmlFor="admin-email">Correo</label>
                <input
                  id="admin-email"
                  type="email"
                  value={email}
                  autoComplete="username"
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="admin@correo.com"
                  required
                />
              </div>
              <div className="field-block">
                <label htmlFor="admin-password">Contraseña</label>
                <input
                  id="admin-password"
                  type="password"
                  value={password}
                  autoComplete="current-password"
                  onChange={(event) => setPassword(event.target.value)}
                  placeholder="********"
                  required
                />
              </div>
              <button type="submit" className="btn-primary" disabled={authBusy}>
                {authBusy ? "Entrando..." : "Entrar al panel"}
              </button>
            </form>
            {authError && <p className="status error">{authError}</p>}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="admin-panel">
      <div className="container">
        <div className="admin-header">
          <p className="admin-panel-label">Lucero &amp; Miguel</p>
          <h2 className="admin-panel-title">Panel de Invitaciones</h2>
          <div className="admin-panel-rule"></div>
          <p className="admin-auth-user">Sesión activa: <strong>{authUser.email}</strong></p>
          <button
            type="button"
            className="btn-secondary"
            onClick={handleLogout}
            disabled={authBusy}
          >
            {authBusy ? "Cerrando..." : "Cerrar sesión"}
          </button>
        </div>

        <div className="panel-nav">
          <NavLink
            to="/panel/crear"
            className={({ isActive }) =>
              isActive ? "panel-nav-link active" : "panel-nav-link"
            }
          >
            Crear invitación
          </NavLink>
          <NavLink
            to="/panel/gestionar"
            className={({ isActive }) =>
              isActive ? "panel-nav-link active" : "panel-nav-link"
            }
          >
            Gestionar Invitaciones
          </NavLink>
          <NavLink
            to="/panel/confirmados"
            className={({ isActive }) =>
              isActive ? "panel-nav-link active" : "panel-nav-link"
            }
          >
            Confirmados
          </NavLink>
        </div>

        <Routes>
          <Route path="/" element={<Navigate to="/panel/crear" replace />} />
          <Route path="/crear" element={<CreatePage />} />
          <Route path="/gestionar" element={<ManagePage />} />
          <Route path="/confirmados" element={<ConfirmadosPage />} />
        </Routes>
      </div>
    </section>
  );
};

export default AdminPanel;
